import { useContext } from 'react';

import { CookieConsentContext } from '../../../../contexts';
import { Box, Flex, Translate } from '../../../atoms';
import { CookieConsentProps } from '../types';
import { ConsentButton } from '../styles';
import { AcceptButton, ManageLink, SimplifiedContainer, Subtitle, Title } from './styles';

interface SimplifiedCookieConsentProps extends CookieConsentProps {
  onShowFull: () => void;
}

export const SimplifiedCookieConsent = ({ onShowFull, ...props }: SimplifiedCookieConsentProps) => {
  const consent = useContext(CookieConsentContext);

  const handleAccept = () => {
    const allEnabled = {
      necessary: true,
      statistics: true,
    };
    consent.selectCookieSections(allEnabled);
  };

  return (
    <SimplifiedContainer {...props}>
      <Flex justifyContent="space-between" alignItems="flex-start">
        <Box flex="1" mr={3}>
          <Title>
            <Translate i18nKey="components.cookieConsent.thisSiteUsesCookie" />
          </Title>
          <Subtitle>
            <Translate i18nKey="components.cookieConsent.manageYourPrivacyChoices" />{' '}
            <ManageLink onClick={onShowFull}>
              <Translate i18nKey="components.cookieConsent.here" />
            </ManageLink>
          </Subtitle>
        </Box>
      </Flex>
      <AcceptButton as={ConsentButton} onClick={handleAccept}>
        <Translate i18nKey="components.cookieConsent.accept" />
      </AcceptButton>
    </SimplifiedContainer>
  );
};
